<template>
  <div style="width:100%">
    <Header :title="$t('m.ResetPass')"></Header>
    <div class="banner">
      <div class="stylebanner1" id="bannerMobile1"></div>
    </div>
    <div class="form">
      <div class="formitem">
        <input :type="bool?'password':'text'" autocomplete='off' :placeholder="$t('m.PlsEnterOldPassword')" style="border:none;outline:none"
               v-model="value">
        <span @click="booldo" class="icon" v-if="value"><Icon class="color" type="ios-eye" v-if="bool"></Icon><Icon
          class="color" type="ios-eye-off" v-if="!bool"></Icon></span>
      </div>
      <div class="formitem">
        <input :type="bool1?'password':'text'" :placeholder="$t('m.PlsEnterNewPassword')" style="border:none;outline:none" v-model="value1">
        <span @click="booldo1" class="icon" v-if="value1"><Icon class="color" type="ios-eye" v-if="bool1"></Icon><Icon
          class="color" type="ios-eye-off" v-if="!bool1"></Icon></span>
      </div>
      <div class="formitem">
        <input :type="bool2?'password':'text'" autocomplete='off' :placeholder="$t('m.PlsDoubleEnterNewPassword')" style="border:none;outline:none"
               v-model="value2">
        <span @click="booldo2" class="icon" v-if="value2"><Icon class="color" type="ios-eye" v-if="bool2"></Icon><Icon
          class="color" type="ios-eye-off" v-if="!bool2"></Icon></span>
      </div>
      <div :class="{bgc:(value1&&value2&&value),button:true}" @click="sub">{{$t('m.OKBtn')}}</div>
    </div>
    <div class="logo">
      <div class="stylebanner2"></div>
    </div>
    <div class="modelwrap" v-if="model1">
      <div class="model">
        <div class="modeltitle">{{$t('m.ModifySuccessful')}}</div>
        <div @click="sure" class="modelact color">OK</div>
      </div>
    </div>
  </div>
</template>
<script>
  import Header from "../header/header";
  import {changepassword} from "../../assets/js/url";

  export default {
    name: "resetpassword",
    data() {
      return {
        value: "",
        value1: "",
        value2: "",
        bool: true,
        bool1: true,
        bool2: true,
        model1: false
      };
    },
    components: {
      Header
    },
    activated() {
	  document.getElementById("bannerMobile1").style.background = 'url('+window.localStorage.getItem("bannerMobile")+') center center no-repeat';
	  document.getElementById("bannerMobile1").style.backgroundSize = '100% 100%';
    },
    methods: {
      booldo() {
        this.bool = false;
        const _this = this
        setTimeout(function () {
          _this.bool = true;
        }, 3000);
      },
      booldo1() {
        this.bool1 = false;
        const _this = this
        setTimeout(function () {
          _this.bool1 = true;
        }, 3000);
      },
      booldo2() {
        this.bool2 = false;
        const _this = this
        setTimeout(function () {
          _this.bool2 = true;
        }, 3000);
      },
      sure() {
        this.$router.push({path: "/login"});
        this.value = "";
        this.value1 = "";
        this.value2 = "";
      },
      sub() {
        if (this.value && this.value1 && this.value2) {
          if (this.value1 == this.value2) {
            this.$http
              .post(changepassword, {
                oldpassword: this.value,
                newpassword: this.value2,
                useruuid: window.sessionStorage.getItem("UUID")
              })
              .then(
                res => {
                  if (res.data.status == 2000) {
                    this.model1 = true;
                    window.localStorage.removeItem("password");
                  } else {
                    this.$toast(this.$t('m.ModifyPassFail'));
                  }
                },
                err => {
                  this.$toast(this.$t('m.NetworkErrorPassModifyFail'));
                }
              );
          } else {
            this.$toast(this.$t('m.TwoTimePassNotEqual'));
          }
        } else {
          this.$toast(this.$t('m.PlsEnterAllInfo'));
        }
      }
    }
  };
</script>
<style scoped>
  .banner {
    margin-top: 0.3rem;
    width: 100%;
    height: 0.48rem;
    text-align: center;
  }

  .banner img {
    width: 2.3rem;
  }

  .form {
    margin: 0.3rem 0.3rem 0.2rem;
    height: 1.5rem;
    position: relative;
  }

  .hide {
    width: 0;
    height: 0;
    position: absolute;
    opacity: 0;
    top: -200px;
    left: 0;
  }

  .formitem {
    width: 100%;
    height: 0.5rem;
    background-color: #f6f7fa;
    border-radius: 3px;
    margin-top: 6px;
    box-sizing: border-box;
    padding: 0 0.15rem;
  }

  .formitem input {
    height: 0.5rem;
    width: 2.5rem;
    background-color: transparent;
    border: none;
    outline: none;
  }

  .formitem input:visited {
    border: none;
  }

  .formitem input:focus {
    border: none;
  }

  .formitem input:active {
    border: none;
  }

  .button {
    width: 100%;
    height: 0.44rem;
    background-color: #bec9bc;
    border-radius: 0.3rem;
    margin-top: 0.2rem;
    box-sizing: border-box;
    padding: 0 0.15rem;
    text-align: center;
    line-height: 0.44rem;
    font-size: 0.16rem;
    color: #fff;
  }

  .logo {
    margin-top: 1rem;
    width: 100%;
    height: 0.26rem;
    text-align: center;
  }

  .logo img {
    width: 1.01rem;
    height: 0.26rem;
  }

  i {
    font-size: 0.2rem;
    vertical-align: middle;
  }

  .icon {
    height: 0.5rem;
    line-height: 0.5rem;
    float: right;
  }

  .modelwrap {
    width: 100%;
    height: 100%;
    top: 0.44rem;
    left: 0px;
    position: fixed;
    background: rgba(0, 0, 0, .4)
  }

  .model {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -0.54rem;
    margin-left: -1.35rem;
    width: 2.70rem;
    height: 1.08rem;
    background-color: #fff;
    border-radius: 0.12rem;
    box-sizing: border-box;
    padding: 0.20rem 0.06rem;
  }

  .modeltitle {
    text-align: center;
    height: 0.34rem;
    line-height: 0.34rem;
    font-size: 0.17rem;
    color: #000;
  }

  .modelact {
    text-align: center;
    height: 0.34rem;
    line-height: 0.34rem;
    font-size: 0.17rem;
    color: #000;
  }
</style>




// WEBPACK FOOTER //
// src/components/login/resetpassword.vue